import type { FC } from 'react';
import React, { useCallback } from 'react';

import { ICON_SIZE_MAP } from '../../../constants';
import { PauseIcon } from '../../assets/PauseIcon';
import { PlayIcon } from '../../assets/PlayIcon';
import { Tooltip } from '../Tooltip/Tooltip';

import styles from './PlayToggle.module.scss';

type PlayToggleProps = {
  isPlaying: boolean;
  size: 'medium' | 'large';
  onPlay: () => void;
  onPause: () => void;
};

export const PlayToggle: FC<PlayToggleProps> = ({
  isPlaying,
  size,
  onPause,
  onPlay,
}) => {
  const iconSize = ICON_SIZE_MAP[size];
  const tooltipContent = isPlaying ? 'Pause' : 'Play';
  const ariaLabel = isPlaying ? 'Pause' : 'Play';

  const handlePlayToggle = useCallback(() => {
    if (isPlaying) {
      return onPause();
    }
    onPlay();
  }, [isPlaying, onPlay, onPause]);

  return (
    <Tooltip content={tooltipContent}>
      <button
        className={styles.button}
        type="button"
        tabIndex={0}
        aria-label={ariaLabel}
        onClick={handlePlayToggle}
      >
        {isPlaying ? (
          <PauseIcon width={iconSize} height={iconSize} />
        ) : (
          <PlayIcon width={iconSize} height={iconSize} />
        )}
      </button>
    </Tooltip>
  );
};
